export default __webpack_public_path__ + "static/media/Shemrin.754f5e42.jpg";